// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__mVc8K","list":"BalanceDue_list__VagY1","listRow":"BalanceDue_listRow__19Q0e","total":"BalanceDue_total__2NZiX"};